export class EmployeeLaborAllocation {
  JobCodeId: number;
  PercentageOfGrossPay: number;

  constructor(code: number, percent: number) {
    this.JobCodeId = code;
    this.PercentageOfGrossPay = percent;
  }
}

export class EmployeeLaborAllocationHistory {
  JobCodeId: number;
  Description: string;
  OldValue: number;
  NewValue: number;
  ChangedOn: Date;
  ChangedBy: string; // human-readable name for user who mod’d record
}

export class JobCode {
  Id: number;
  Code: string;
  Description: string;

  constructor(code: string, descrip: string) {
    this.Id = 0;
    this.Code = code;
    this.Description = descrip;
  }
}

export enum LaborAllocationTypes {
  'None' = 0,
  'Department' = 1,
  'Job Code' = 2
}
